import { Fragment, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import DatePicker from "react-datepicker";
import * as datePickerLocales from "date-fns/locale";
import DateUtils from 'src/services/utils/DateUtils';
import { convertToHTML } from 'draft-convert';
import { ContentState, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { convertFromHTML } from 'draft-js';
import { TbLoader } from 'react-icons/tb';
import { Button, Card, CardHeader, Col, Container, Input, InputGroup, Label, ListGroup, ListGroupItem, Row, Table } from 'reactstrap';
import TaskManagerService from "src/modules/data-protection/apis/TaskManagerService";
import {
    DESCRIPTION_IS_REQUIRED,
    UPDATE_CATEGORY_SUCCESSFUL,
    UPDATE_CATEGORY_FAILED,
    UPDATE_DESCRIPTION_SUCCESSFUL,
    UPDATE_DESCRIPTION_FAILED,
    UPDATE_OWNER_SUCCESSFUL,
    UPDATE_OWNER_FAILED,
    UPDATE_STATUS_SUCCESSFUL,
    UPDATE_STATUS_FAILED,
    UPDATE_PRIORITY_SUCCESSFUL,
    UPDATE_PRIORITY_FAILED,
    UPDATE_DEADLINE_SUCCESSFUL,
    UPDATE_DEADLINE_FAILED,
    FETCH_TASK_FAILED,
    INTERNATIONAL_DATE_FORMAT,
    FETCH_COMMENTS_FAILED,
    CATEGORY_IS_REQUIRED,
    UPDATE_START_DATE_SUCCESSFUL,
    UPDATE_START_DATE_FAILED
} from 'src/common/constants';
import Select from 'react-select';

import DownloadAttachments from '../../attachments';

import { formatTaskAndRiskId } from "src/modules/data-protection/constants/Common"

import {
    API_BASE_URL,
    API_URL_TASK_DETAILS,
    API_URL_TASK_GET_COMMENTS
} from '../../../../constants';

import CommentsComponent from '../../comments';
import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import {
    TasksStatuses,
    TasksPriorities
} from "src/modules/data-protection/constants";
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import { withRouter } from 'react-router-dom';
import EditRecurringTaskConfirmModal from './components/EditRecurringTaskConfirmModal';
import StatusChangeConfirmModal from './components/StatusChangeConfirmModal';
import { IoIosArrowBack } from 'react-icons/io';
import DeleteTaskModal from "src/modules/data-protection/components/RisksAndTasks/tasks/delete-modal";
import ISMSControls from './components/ISMSControls';
import UserUtils from 'src/services/utils/UserUtils';

const TaskDetails = function (props) {
    const dateUtils = useMemo(() => {
        return new DateUtils();
    }, []);

    const userUtils = new UserUtils();

    const {
        t,
        token,
        user,
        lng,
        taskId,
        canUserEdit = true,
        onTaskDataFetched,
        showBackButton = true,
        onBackClicked,
        onRelatedTaskClicked,
        ismsControlsOptions
    } = props;

    const isTaskOwnerEmployee = userUtils.isTaskOwner(user);

    const [task, setTask] = useState(null);
    const [comments, setComments] = useState(null);
    const [categories, setCategories] = useState([]);
    const [owners, setOwners] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categoryOtherError, setCategoryOtherError] = useState(null);
    const [selectedSubCategoryOtherString, setSelectedSubCategoryOtherString] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [description, setDescription] = useState(EditorState.createEmpty());
    const [descriptionError, setDescriptionError] = useState(null);
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [selectedPriority, setSelectedPriority] = useState(null);
    const [selectedDeadline, setSelectedDeadline] = useState(null);

    const [loadingTask, setLoadingTask] = useState(null);
    const [loadingCategory, setLoadingCategory] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [loadingDescription, setLoadingDescription] = useState(false);
    const [loadingOwner, setLoadingOwner] = useState(false);
    const [loadingPriority, setLoadingPriority] = useState(false);
    const [loadingDeadline, setLoadingDeadline] = useState(false);
    const [loadingStartedAt, setLoadingStartedAt] = useState(false);
    const [loadingComments, setLoadingComments] = useState(false);

    const [recurringTaskEditModalOptions, setRecurringTaskEditModalOptions] = useState({
        show: false,
        title: '',
        checkBoxText: '',
        action: null,
        inProcess: false
    })

    const [showChangeStatusConfirmModal, setShowChangeStatusConfirmModal] = useState({
        show: false,
        status: null
    });
    const [deleteTaskModalStatus, setDeleteTaskModalStatus] = useState(false);


    const priorities = [];
    const taskStatuses = [];

    for (const priorityKey in TasksPriorities) {
        const priority = TasksPriorities[priorityKey];
        priorities.push({
            value: priorityKey,
            baseLabel: priority.title,
            label: (
                <>
                    <span style={{
                        color: `${priority.color}`
                    }}>
                        {priority.icon}
                    </span>
                    <span>
                        {t(priority.title)}
                    </span>
                </>
            ),
        });
    }

    for (const statusKey in TasksStatuses) {
        const status = TasksStatuses[statusKey];
        taskStatuses.push({
            value: statusKey,
            label: t(status.title),
            baseLabel: status.title
        });
    }

    const handleDeleteTaskMutation = useMutation({
            mutationFn: async (taskId) => {
                const service = TaskManagerService.getInstance();
                
                return await service.deleteTask(task?.report_case_id, taskId);
            },
            onSuccess: async () => {
                setDeleteTaskModalStatus(false);
                toast(t("Task deleted successfully."), {
                    type: "success",
                });
                setShowChangeStatusConfirmModal({
                    show: false,
                    status: null
                })
                onBackClicked();
            },
            onError: () => {
                toast(t("Failed to delete task."), {
                    type: "error",
                });
            },
        });

    const handleFetchTasksCategories = useQuery({
        queryKey: ['fetch-tasks-categories'],
        queryFn: async () => {
            const service = TaskManagerService.getInstance();

            return await (task.is_mitigation ? service.fetchMitigationCategories() : service.fetchCategories());
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: false,
        onError: (error) => {
            toast(t('An error occurred while fetching categories.'), {
                type: 'error',
            });
        }
    });

    const handleFetchTasksOwners = useQuery({
        queryKey: ['data-protection-fetch-tasks-owners'],
        queryFn: async () => {
            const service = TaskManagerService.getInstance();

            return await service.fetchOwners();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: canUserEdit,
        onError: (error) => {
            toast(t('An error occurred while fetching owners.'), {
                type: 'error',
            });
        }
    });

    const handleFetchRecurringTaskChildren = useQuery({
        queryKey: [
            'data-protection-fetch-task-children',
            taskId
        ],
        queryFn: async () => {
            const service = TaskManagerService.getInstance();

            return await service.fetchRecurringTaskChildren(taskId, {
                pageIndex: 1,
                pageSize: 100,
                sortField: 'id',
                sortOrder: 'ASC'
            });
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: false,
        onError: () => {
            toast(t('An error occurred while fetching recurring tasks.'), {
                type: 'error',
            });
        }
    });

    const handleFetchTask = async () => {
        setLoadingTask(true);

        try {
            const result = await axios.get(`${API_URL_TASK_DETAILS}/task/${taskId}/show`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (result.status === 200) {
                setTask(result.data.data);

                if (result.data.data.is_recurring && !result.data.data?.parent_task?.id) {
                    handleFetchRecurringTaskChildren.refetch();
                }

                handleFetchTasksCategories.refetch();
                onTaskDataFetched && onTaskDataFetched(result.data.data);
            }
            else {
                toast(t(FETCH_TASK_FAILED), {
                    type: 'error',
                });
            }
        }
        catch (error) {
            toast(t(FETCH_TASK_FAILED), {
                type: 'error',
            });
        }

        setLoadingTask(false);
    }

    const resetRecurringEditModal = () => {
        setRecurringTaskEditModalOptions({
            show: false,
            title: '',
            checkBoxText: '',
            action: null,
            inProcess: false
        })
    }

    const handleSubmitChangeCategory = async (
        category,
        subCategory,
        applyToAll
    ) => {
        if (!category && !subCategory) {
            setCategoryOtherError(t(CATEGORY_IS_REQUIRED));
            return;
        }
        else {
            setCategoryOtherError(null);
        }

        setLoadingCategory(true);

        const data = !subCategory ? {
            category: category,
            editRecurring: applyToAll ? true : undefined
        } : {
            category: null,
            otherCategory: subCategory,
            editRecurring: applyToAll ? true : undefined
        };

        try {
            const result = await axios.post(
                `${API_BASE_URL}/task/${taskId}/change_category`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                },
            );

            if (result.status === 200) {
                setTask({
                    ...task,
                    category: {
                        ...task.category,
                        is_other_category: data.otherCategory ? true : false,
                        id: data.otherCategory ? selectedCategory.value : data.category,
                        name: data.otherCategory
                    }
                });

                toast(t(UPDATE_CATEGORY_SUCCESSFUL), {
                    type: 'success',
                });
            }
            else {
                toast(t(UPDATE_CATEGORY_FAILED), {
                    type: 'error',
                });
            }
        }
        catch (error) {
            toast(t(UPDATE_CATEGORY_FAILED), {
                type: 'error',
            });
        }
        setLoadingCategory(false);
        resetRecurringEditModal()
    }

    const handleChangeCategory = (category) => {
        if (category.baseLabel.toLowerCase() !== 'other') {
            if (task.is_recurring && !task.parent_task?.id) {
                setRecurringTaskEditModalOptions((currentState) => {
                    return {
                        ...currentState,
                        show: true,
                        title: 'Apply Category Change',
                        checkBoxText: 'Apply This Category Change to All Occurrences',
                        action: 'category',
                        category: category.value
                    }
                })
            }
            else {
                handleSubmitChangeCategory(category.value, null);
            }
        }
        else {
            setSelectedCategory(category);
        }
    }

    const handleChangeStatus = async (status) => {
        const prevStatus = Object.create(selectedStatus);

        setLoadingStatus(true);

        try {
            if (status.value === 'DELETED') {
                return setDeleteTaskModalStatus(true);
            }
            else {
                const result = await axios.post(
                    `${API_BASE_URL}/task/${taskId}/change_status`,
                    {
                        status: status.value,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    },
                );

                if (result.status === 200) {
                    const taskNewValues = {
                        status: status.value
                    };

                    if (status.value === 'IN_PROGRESS' && result.data?.data?.startedAt) {
                        taskNewValues.started_at = result.data?.data?.startedAt
                    }

                    setTask({
                        ...task,
                        ...taskNewValues
                    });

                    toast(t(UPDATE_STATUS_SUCCESSFUL), {
                        type: 'success',
                    });
                } else {
                    toast(t(UPDATE_STATUS_FAILED), {
                        type: 'error',
                    });
                }
            }
        }
        catch (error) {
            toast(t(UPDATE_STATUS_FAILED), {
                type: 'error',
            });
        }

        setLoadingStatus(false);
        setShowChangeStatusConfirmModal({
            show: false,
            status: null
        })
    }

    const handleDescriptionSubmit = async (applyToAll = false) => {
        try {
            if (!description.getCurrentContent().hasText()) {
                setDescriptionError(DESCRIPTION_IS_REQUIRED);
                return;
            }
            else {
                setDescriptionError(null);
            }

            setLoadingDescription(true);

            const descToSend = convertToHTML(description.getCurrentContent());

            const result = await axios.post(
                `${API_BASE_URL}/task/${taskId}/update`,
                {
                    description: descToSend,
                    descriptionAttachments: [],
                    editRecurring: applyToAll ? true : undefined
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                },
            );

            if (result.status === 200) {
                setTask((currentState) => {
                    return {
                        ...currentState,
                        description: descToSend
                    }
                });

                toast(t(UPDATE_DESCRIPTION_SUCCESSFUL), {
                    type: 'success',
                });
            }
            else {
                toast(t(UPDATE_DESCRIPTION_FAILED), {
                    type: 'error',
                });
            }
        }
        catch (error) {
            toast(t(UPDATE_DESCRIPTION_FAILED), {
                type: 'error',
            });
        }
        resetRecurringEditModal();
        setLoadingDescription(false);
    };

    const handleChangeOwner = async (owner, applyToAll = false) => {
        try {
            setLoadingOwner(true);

            const result = await axios.post(
                `${API_BASE_URL}/task/${taskId}/assign_analyst`,
                {
                    analyst: owner.value,
                    editRecurring: applyToAll ? true : undefined
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                },
            );

            if (result.status === 200) {
                setTask({
                    ...task,
                    owner_object: {
                        id: owner.value,
                        name: owner.baseLabel
                    }
                });

                toast(t(UPDATE_OWNER_SUCCESSFUL), {
                    type: 'success',
                });
            }
            else {
                toast(t(UPDATE_OWNER_FAILED), {
                    type: 'error',
                });
            }
        }
        catch (error) {
            toast(t(UPDATE_OWNER_FAILED), {
                type: 'error',
            });
        }

        resetRecurringEditModal();
        setLoadingOwner(false);
    };

    const handleChangePriority = async (priority) => {
        setLoadingPriority(true);

        try {
            const result = await axios.post(
                `${API_BASE_URL}/task/${taskId}/change_priority`,
                {
                    priority: priority.value,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            if (result.status === 200) {
                setTask({
                    ...task,
                    priority: priority.value
                });

                toast(t(UPDATE_PRIORITY_SUCCESSFUL), {
                    type: 'success',
                });
            }
            else {
                toast(t(UPDATE_PRIORITY_FAILED), {
                    type: 'error',
                });
            }
        }
        catch (error) {
            toast(t(UPDATE_PRIORITY_FAILED), {
                type: 'error',
            });
        }

        setLoadingPriority(false);
    };

    const handleChangeDeadline = async (deadline) => {
        try {
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0)

            const selectedDate = new Date(deadline);
            selectedDate.setHours(0, 0, 0, 0);

            if (selectedDate.getTime() < currentDate.getTime()) {
                toast(t('deadline is not valid'), {
                    type: 'error',
                });

                return false;
            }

            setLoadingDeadline(true);

            const result = await axios.post(
                `${API_BASE_URL}/task/${taskId}/change_deadline`,
                { endedAt: format(selectedDate, 'yyyy-MM-dd') },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                },
            );

            if (result.status === 200) {
                setSelectedDeadline(deadline);

                toast(t(UPDATE_DEADLINE_SUCCESSFUL), {
                    type: 'success',
                });
            }
            else {
                toast(t(UPDATE_DEADLINE_FAILED), {
                    type: 'error',
                });
            }
        }
        catch (error) {
            toast(t(UPDATE_DEADLINE_FAILED), {
                type: 'error',
            });
        }

        setLoadingDeadline(false);
    };

    const handleFetchComments = async () => {
        setComments(null);
        setLoadingComments(true);

        try {
            const result = await axios.get(
                `${API_URL_TASK_GET_COMMENTS}/task/${taskId}/comments`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                },
            );

            if (result.status === 200) {
                setComments(result.data.data);
            }
            else {
                toast(t(FETCH_COMMENTS_FAILED), {
                    type: 'error',
                });
            }
        }
        catch (error) {
            toast(t(FETCH_COMMENTS_FAILED), {
                type: 'error',
            });
        }

        setLoadingComments(false);
    };

    const handleUpdateAttachmentName = (name, id) => {
        const index = task.description_attachments.findIndex((i) => i.id === id);

        if (index > -1) {
            const description_attachments = Array.from(task.description_attachments);
            description_attachments[index].origin_name = name;

            setTask({
                ...task,
                description_attachments,
            });
        }
    };

    const findAndUpdateTaskCategory = () => {
        if (!categories.length) return;

        if (task?.category?.is_other_category) {
            const category = categories.find((c) => c.baseLabel.toLowerCase() === 'other');

            setSelectedCategory({
                ...category,
                label: t(category.baseLabel)
            });

            setSelectedSubCategoryOtherString(task.category.name);
        }
        else {
            const category = categories.find((c) => c.value === task?.category?.id);

            setSelectedCategory({
                ...category,
                label: t(category?.baseLabel)
            });

            setSelectedSubCategoryOtherString('');
        }
    }

    const findAndUpdateTaskStatus = () => {
        if (!taskStatuses.length) return;

        const status = taskStatuses.find((s) => s.value === task.status);
        setSelectedStatus(status);
    }

    const findAndUpdateTaskOwner = () => {
        if (!owners.length) return;

        const owner = owners.find((o) => o.value === task.owner_object?.id);
        setSelectedOwner(owner);
    }

    const findAndUpdateTaskPriority = () => {
        if (!priorities.length) return;

        const priority = priorities.find((o) => o.value === task.priority);
        setSelectedPriority(priority);
    }

    const handleChangeStartedAt = async (startedAt) => {
        try {
            setLoadingStartedAt(true);

            const result = await axios.post(
                `${API_BASE_URL}/task/${taskId}/change_start_date`,
                { startedAt: format(startedAt, 'yyyy-MM-dd') },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );

            if (result.status === 200) {
                setTask({
                    ...task,
                    started_at: dateUtils.convertDateToTimeStamp(startedAt)
                });

                toast(t(UPDATE_START_DATE_SUCCESSFUL), {
                    type: 'success',
                });
            }
            else {
                toast(t(UPDATE_START_DATE_FAILED), {
                    type: 'error',
                });
            }
        }
        catch (error) {
            toast(t(UPDATE_START_DATE_FAILED), {
                type: 'error',
            });
        }

        setLoadingStartedAt(false);
    };

    const renderStartedAt = () => {
        if (!task || loadingStartedAt) {
            return <div className='dt-field dt-skeleton' style={{ height: 27 }} />
        }

        if (!task.started_at) {
            return (
                <DatePicker
                    locale={datePickerLocales[lng]}
                    name="startedAtDate"
                    id="startedAtDate"
                    className="form-control"
                    dateFormat={'dd/MM/yyyy'}
                    showTimeSelect={false}
                    minDate={new Date()}
                    onChange={handleChangeStartedAt}
                    disabled={!canUserEdit}
                />
            )
        }

        return (
            <Label style={{ marginBottom: 0, lineHeight: '26px' }}>
                {dateUtils.convertTimeStampToDate(task.started_at, INTERNATIONAL_DATE_FORMAT)}
            </Label>
        )
    }

    const handleRecurringTaskEditModalConfirm = (applyToAll) => {
        setRecurringTaskEditModalOptions((currentState) => {
            return {
                ...currentState,
                inProcess: true
            }
        });

        if (recurringTaskEditModalOptions.action === 'category') {
            handleSubmitChangeCategory(
                recurringTaskEditModalOptions.category,
                null,
                applyToAll
            );
        }
        else if (recurringTaskEditModalOptions.action === 'subcategory') {
            handleSubmitChangeCategory(
                null,
                selectedSubCategoryOtherString,
                applyToAll
            );
        }
        else if (recurringTaskEditModalOptions.action === 'description') {
            handleDescriptionSubmit(applyToAll)
        }
        else if (recurringTaskEditModalOptions.action === 'owner') {
            handleChangeOwner(
                recurringTaskEditModalOptions.owner,
                applyToAll
            );
        }
    }

    useEffect(() => {
        if (task) {
            findAndUpdateTaskCategory();
            findAndUpdateTaskStatus();
            findAndUpdateTaskOwner();
            findAndUpdateTaskPriority();

            if (task.ended_at) {
                setSelectedDeadline(
                    new Date(task.ended_at * 1000)
                );
            }

            const blocksFromHTML = task.description ? convertFromHTML(task.description) : '';
            const state = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);

            setDescription(EditorState.createWithContent(state));
        }
    }, [task, categories, owners, t]);

    useEffect(() => {
        if (handleFetchTasksCategories.data) {
            setCategories(handleFetchTasksCategories.data.map((item) => {
                return {
                    value: item.id,
                    baseLabel: item.name,
                    label: t(item.name),
                };
            }));
        }
    }, [handleFetchTasksCategories.data]);

    useEffect(() => {
        if (handleFetchTasksOwners.data) {
            setOwners(handleFetchTasksOwners.data.map((item) => {
                return {
                    value: item.id,
                    label: `${item.first_name} ${item.last_name}`,
                    baseLabel: `${item.first_name} ${item.last_name}`
                };
            }));
        }
    }, [handleFetchTasksOwners.data]);

    useEffect(() => {
        if (taskId) {
            setComments(null);
            handleFetchComments();
        }
    }, [
        taskId
    ]);

    useEffect(() => {
        if(taskId){
            setTask(null);
            handleFetchTask();
        }
    }, [
        taskId,
        lng
    ]);

    return (
        <div className='task-detail-container'>
            <DeleteTaskModal
                isOpen={deleteTaskModalStatus}
                taskId={taskId}
                close={() => {
                    setDeleteTaskModalStatus(false);
                }}
                acceptDeletion={(id) => {
                    handleDeleteTaskMutation.mutate(id);
                }}
                inProcess={ handleDeleteTaskMutation.isPending ?? handleDeleteTaskMutation.isLoading}
            />

            {showBackButton && (
                <Row className='mb-3'>
                    <Col lg='2' md='2' sm='12'>
                        {!loadingTask && task ? (
                            <div
                                onClick={() => {
                                    onBackClicked && onBackClicked();
                                }}
                            >
                                <span
                                    style={{ cursor: 'pointer' }}
                                    color='bg-secondary'
                                >
                                    <span className='h3'>
                                        <IoIosArrowBack />
                                    </span>
                                </span>

                                <span
                                    style={{
                                        display: 'inline-block',
                                        position: 'relative',
                                        top: '-0.1rem',
                                        cursor: 'pointer',
                                    }}
                                >

                                    {formatTaskAndRiskId(
                                        'task',
                                        task?.questionnaire === "software" || task.questionnaire === "other_asset" ? task?.asset_id : task?.case_secondary_id,
                                        task.secondary_id,
                                        task?.is_mitigation,
                                        task?.questionnaire,
                                        task.secondary_id
                                    )}

                                </span>
                            </div>
                        ) : (
                            <span style={{ height: 30, display: 'block' }}></span>
                        )}
                    </Col>
                </Row>
            )}

            <Container>
                <Row>
                    <Col lg='8' md='8' sm='12'>
                        <Row className='mb-5'>
                            <Col sm='12' md='6' lg='3'>
                                <Label className='form-label'>{`${t('Title')} `}</Label>
                                <br />
                                {!loadingTask && task ? (
                                    <Label className='form-label text-secondary '>{task.name}</Label>
                                ) : (
                                    <div className='dt-field dt-skeleton dt-select-list' style={{ marginBottom: 16 }}></div>
                                )}
                            </Col>

                            <Col
                                sm='12'
                                md={selectedCategory && selectedCategory?.baseLabel?.toLowerCase() === 'other' ? 3 : 4}
                                lg={selectedCategory && selectedCategory?.baseLabel?.toLowerCase() === 'other' ? 3 : 4}
                            >
                                <Label className='form-label'>{`${t('Category')} `}</Label>
                                <br />

                                {!loadingCategory && !loadingTask && categories && task ? (
                                    <Select
                                        name='category'
                                        classNamePrefix='select2-selection'
                                        options={categories.map((c) => {
                                            return {
                                                value: c.value,
                                                baseLabel: c.baseLabel,
                                                label: t(c.baseLabel),
                                            };
                                        })}
                                        value={selectedCategory}
                                        onChange={(e) => {
                                            handleChangeCategory(e);
                                        }}
                                        menuPortalTarget={document.body}
                                        isDisabled={!canUserEdit || task.status === "CLOSED" ? true : false}
                                    />
                                ) : (
                                    <div className='dt-field dt-skeleton dt-select-list' style={{ marginBottom: 16 }}></div>
                                )}
                            </Col>

                            {/* subcategory */}
                            <Col sm='12' md='3' lg='3' hidden={!selectedCategory || selectedCategory?.baseLabel?.toLowerCase() !== 'other'}>
                                <Label className='form-label text-dark'>{`${t('Subcategory')} `}</Label>
                                <InputGroup>
                                    <Input
                                        name='sub-cat'
                                        type='text'
                                        className='form-control'
                                        value={selectedSubCategoryOtherString}
                                        validate={{ required: { value: true } }}
                                        onChange={(e) => {
                                            setSelectedSubCategoryOtherString(e.target.value);
                                        }}
                                        disabled={!canUserEdit}
                                    />
                                    {canUserEdit ? (
                                        <Button
                                            color='primary'
                                            onClick={() => {
                                                if (task.is_recurring && !task.parent_task?.id) {
                                                    setRecurringTaskEditModalOptions((currentState) => {
                                                        return {
                                                            ...currentState,
                                                            show: true,
                                                            title: 'Apply Category Change',
                                                            checkBoxText: 'Apply This Category Change to All Occurrences',
                                                            action: 'subcategory',
                                                            category: selectedSubCategoryOtherString
                                                        }
                                                    })
                                                }
                                                else {
                                                    handleSubmitChangeCategory(
                                                        null,
                                                        selectedSubCategoryOtherString
                                                    );
                                                }
                                            }}
                                        >
                                            {t('Save')}
                                        </Button>
                                    ) : null}
                                </InputGroup>
                                <br />
                                <p className='text-danger'>{categoryOtherError ? t(categoryOtherError) : ''}</p>
                            </Col>

                            {/* status */}
                            <Col
                                sm='12'
                                md={selectedCategory && selectedCategory?.baseLabel?.toLowerCase() === 'other' ? 3 : 4}
                                lg={selectedCategory && selectedCategory?.baseLabel?.toLowerCase() === 'other' ? 3 : 4}
                            >
                                <Label className='form-label'>
                                    {`${t('Status')} `}
                                </Label>
                                {!loadingStatus && !loadingTask && taskStatuses && task ? (
                                    <Select
                                        required
                                        name='status'
                                        classNamePrefix='select2-selection'
                                        options={taskStatuses}
                                        value={selectedStatus}
                                        onChange={(status) => {
                                            if (!task.is_started) {
                                                setShowChangeStatusConfirmModal((currentState) => {
                                                    return {
                                                        ...currentState,
                                                        show: true,
                                                        status: status
                                                    }
                                                })
                                            }
                                            else {
                                                handleChangeStatus(status);
                                            }
                                        }}
                                        menuPortalTarget={document.body}
                                        isDisabled={task?.status === "CLOSED"}
                                    ></Select>
                                ) : (
                                    <div className='dt-field dt-skeleton dt-select-list' style={{ marginBottom: 16 }}></div>
                                )}
                            </Col>
                        </Row>

                        {!isTaskOwnerEmployee && !loadingTask && task && (
                            <ISMSControls
                                taskId={task.id}
                                defaultValues={task.controls}
                                isReadOnly={!canUserEdit}
                                controlsOptions={ismsControlsOptions}
                                removedControlsByFramework={task?.removed_controls || {}}
                            />
                        )}

                        <Row>
                            {/* description */}
                            <Col sm='12' md='12' lg='12'>
                                <Label className='form-label'>{`${t('Description')} `}</Label>
                                {task && task.description ? (
                                    !canUserEdit ? (
                                        <p dangerouslySetInnerHTML={{ __html: task.description }}></p>
                                    ) : (
                                        <Fragment>
                                            <br />
                                            <Editor
                                                editorState={description}
                                                toolbarClassName='toolbarClassName'
                                                wrapperClassName='wrapperClassName'
                                                editorClassName='editorClassName'
                                                onEditorStateChange={(e) => {
                                                    setDescription(e);
                                                }}
                                                placeholder={t('Add a description...')}
                                                editorStyle={{
                                                    height: '10rem',
                                                    overflowY: 'scroll',
                                                    borderColor: '#c9c9c9',
                                                    paddingRight: '2em',
                                                }}
                                                toolbar={{
                                                    options: ['inline', 'blockType', 'fontSize', 'fontFamily'],
                                                    inline: {
                                                        options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace'],
                                                        bold: { className: 'bordered-option-classname' },
                                                        italic: { className: 'bordered-option-classname' },
                                                        underline: { className: 'bordered-option-classname' },
                                                        strikethrough: {
                                                            className: 'bordered-option-classname',
                                                        },
                                                        code: { className: 'bordered-option-classname' },
                                                    },
                                                    blockType: {
                                                        className: 'bordered-option-classname',
                                                    },
                                                    fontSize: {
                                                        className: 'bordered-option-classname',
                                                    },
                                                    fontFamily: {
                                                        className: 'bordered-option-classname',
                                                    },
                                                }}
                                            />
                                            <br />
                                            <p className='text-danger'>{descriptionError ? t(descriptionError) : ''}</p>
                                        </Fragment>
                                    )
                                ) : null}
                            </Col>
                        </Row>

                        <Row>
                            {task && task.description && canUserEdit ? (
                                <Col lg='2' md='2' sm='6' className=''>
                                    <Button color='primary' style={{ display: 'block', width: '100%' }} onClick={(e) => {
                                        if (task.is_recurring && !task.parent_task?.id) {
                                            setRecurringTaskEditModalOptions((currentState) => {
                                                return {
                                                    ...currentState,
                                                    show: true,
                                                    title: 'Apply Description Change',
                                                    checkBoxText: 'Apply This Description Change to All Occurrences',
                                                    action: 'description'
                                                }
                                            })
                                        }
                                        else {
                                            handleDescriptionSubmit()
                                        }
                                    }}>
                                        {loadingDescription ? <TbLoader /> : t('Save')}
                                    </Button>
                                </Col>
                            ) : null}

                            {task && task.description_attachments && task.description_attachments.length > 0 ? (
                                <Col lg='10' md='10' sm='6' hidden={!(task && task.description_attachments && task.description_attachments.length > 0)}>
                                    <DownloadAttachments
                                        type={'task'}
                                        style={{ display: 'block', width: '100%' }}
                                        showAttachments={false}
                                        files={task.description_attachments}
                                    />
                                </Col>
                            ) : null}
                        </Row>
                    </Col>

                    <Col lg='4' md='4' sm='12'>
                        <Card
                            outline
                            body
                            className='border border-primary rounded'
                            style={{
                                width: 'auto',
                            }}
                        >
                            <CardHeader>{t('Details')}</CardHeader>
                            <br></br>
                            <ListGroup flush>
                                <ListGroupItem className='border-bottom border-primary'>
                                    <Row>
                                        <Col>
                                            <p>{t('Task Manager')}</p>
                                        </Col>
                                        <Col>
                                            {task ? (
                                                <span className='badge bg-success text-white rounded p-2' style={{ marginBottom: 0, display: 'block' }}>
                                                    {task?.manager?.name}
                                                </span>
                                            ) : (
                                                <div className='dt-field dt-skeleton' style={{ height: 27 }}></div>
                                            )}
                                        </Col>
                                    </Row>
                                </ListGroupItem>

                                {/* owners */}
                                <ListGroupItem className='border-bottom border-primary '>
                                    <Row>
                                        <Col>
                                            <p>{t('Task Owner')}</p>
                                        </Col>
                                        <Col>
                                            {task ? (
                                                !canUserEdit ? (
                                                    <span className='badge bg-success text-white rounded p-2' style={{ marginBottom: 0, display: 'block' }}>
                                                        {task.owner_object.name}
                                                    </span>
                                                ) : !loadingOwner && owners ? (
                                                    <Select
                                                        required
                                                        name='owner'
                                                        classNamePrefix='select2-selection'
                                                        options={owners}
                                                        isDisabled={!task?.manager?.isAiCreated && task?.manager?.id !== user.id}
                                                        value={selectedOwner}
                                                        onChange={(e) => {
                                                            if (task.is_recurring && !task.parent_task?.id) {
                                                                setRecurringTaskEditModalOptions((currentState) => {
                                                                    return {
                                                                        ...currentState,
                                                                        show: true,
                                                                        title: 'Apply Task Owner Change',
                                                                        checkBoxText: 'Apply This Task Owner Change to All Occurrences',
                                                                        action: 'owner',
                                                                        owner: e
                                                                    }
                                                                })
                                                            }
                                                            else {
                                                                handleChangeOwner(e);
                                                            }
                                                        }}
                                                    />
                                                ) : (
                                                    <div className='dt-field dt-skeleton dt-select-list'></div>
                                                )
                                            ) : (
                                                <div className='dt-field dt-skeleton dt-select-list'></div>
                                            )}
                                        </Col>
                                    </Row>
                                </ListGroupItem>

                                {/* priority */}
                                <ListGroupItem className='border-bottom border-primary'>
                                    <Row>
                                        <Col>
                                            <p>{t('Priority')}</p>
                                        </Col>
                                        <Col>
                                            {!loadingPriority && priorities && task ? (
                                                <Select
                                                    required
                                                    name='priority'
                                                    classNamePrefix='select2-selection'
                                                    options={priorities}
                                                    value={selectedPriority}
                                                    onChange={(e) => {
                                                        handleChangePriority(e);
                                                    }}
                                                    isDisabled={!canUserEdit}
                                                />
                                            ) : (
                                                <div className='dt-field dt-skeleton dt-select-list'></div>
                                            )}
                                        </Col>
                                    </Row>
                                </ListGroupItem>

                                {/* created at */}
                                <ListGroupItem className='border-bottom border-primary'>
                                    <Row>
                                        <Col>
                                            <p>{t('Created')}</p>
                                        </Col>
                                        <Col>
                                            {task ? (
                                                <Label style={{ marginBottom: 0, lineHeight: '26px' }}>
                                                    {dateUtils.convertTimeStampToDate(task.created_at, INTERNATIONAL_DATE_FORMAT)}
                                                </Label>
                                            ) : (
                                                <div className='dt-field dt-skeleton' style={{ height: 27 }}></div>
                                            )}
                                        </Col>
                                    </Row>
                                </ListGroupItem>

                                {/* started at */}
                                <ListGroupItem className='border-bottom border-primary'>
                                    <Row>
                                        <Col>
                                            <p>{t('Start Date')}</p>
                                        </Col>
                                        <Col>
                                            {renderStartedAt()}
                                        </Col>
                                    </Row>
                                </ListGroupItem>

                                {/* deadline */}
                                <ListGroupItem>
                                    <Row>
                                        <Col>
                                            <p>{t('Deadline')}</p>
                                        </Col>
                                        <Col>
                                            {!loadingDeadline && task ? (
                                                <DatePicker
                                                    locale={datePickerLocales[lng]}
                                                    name="deadlineDate"
                                                    id="deadlineDate"
                                                    disabled={!canUserEdit || !task.started_at}
                                                    className="form-control"
                                                    selected={selectedDeadline}
                                                    dateFormat={'dd/MM/yyyy'}
                                                    showTimeSelect={false}
                                                    minDate={task.started_at ? new Date(task.started_at * 1000) : null}
                                                    onChange={(e) => {
                                                        handleChangeDeadline(e)
                                                    }}
                                                />
                                            ) : (
                                                <div className='dt-field dt-skeleton dt-select-list'></div>
                                            )}
                                        </Col>
                                    </Row>
                                </ListGroupItem>
                            </ListGroup>
                        </Card>

                        {task?.is_recurring && (
                            <>
                                {!task?.parent_task?.id ? (
                                    <Card
                                        outline
                                        body
                                        className='border border-primary rounded'
                                        style={{
                                            width: 'auto',
                                        }}
                                    >
                                        <CardHeader>{t('Recurring Task Instances')}</CardHeader>

                                        <div
                                            style={{
                                                maxHeight: '300px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            <Table
                                                responsive
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            {t('Title')}
                                                        </th>
                                                        <th>
                                                            {t('Start Date')}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {handleFetchRecurringTaskChildren.isFetching ? (
                                                        <tr>
                                                            <td colSpan='2'>
                                                                {t('Loading')}...
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        <>
                                                            {(handleFetchRecurringTaskChildren?.data?.tasks || []).map((childTask) => {
                                                                const taskStatus = TasksStatuses[childTask.status];

                                                                const isDeleted = childTask.status.toLowerCase() === 'deleted';

                                                                return (
                                                                    <tr>
                                                                        <td>
                                                                            <span
                                                                                style={{
                                                                                    cursor: !isDeleted ? 'pointer' : ''
                                                                                }}
                                                                                onClick={() => {
                                                                                    if (!isDeleted)
                                                                                        onRelatedTaskClicked && onRelatedTaskClicked(childTask.id);
                                                                                }}
                                                                                className={!isDeleted ? 'btn-link' : ''}
                                                                            >
                                                                                {childTask.name + '-' + childTask.recurrence_secondary_id}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <div
                                                                                className='d-flex justify-content-center align-items-start flex-column'
                                                                            >
                                                                                {dateUtils.convertTimeStampToDate(childTask.started_at, INTERNATIONAL_DATE_FORMAT)}
                                                                                <div className='dt-task-status text-dark' style={{
                                                                                    backgroundColor: `${taskStatus.color}`
                                                                                }}>
                                                                                    {t(taskStatus.title)}
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>

                                    </Card>
                                ) : (
                                    <Card
                                        outline
                                        body
                                        className='border border-primary rounded'
                                        style={{
                                            width: 'auto',
                                        }}
                                    >
                                        <CardHeader>
                                            {t('This Is an Instance of a Recurring Task')}
                                        </CardHeader>
                                        <ListGroup flush>
                                            <ListGroupItem>
                                                <Row>
                                                    <Col>
                                                        <p>{t('Parent Task')}</p>
                                                    </Col>
                                                    <Col>
                                                        <p
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() => {
                                                                onRelatedTaskClicked && onRelatedTaskClicked(task.parent_task.id);
                                                            }}
                                                            className="btn-link"
                                                        >
                                                            {task.parent_task.name}
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                        </ListGroup>
                                    </Card>
                                )}
                            </>
                        )}
                    </Col>
                </Row>

                <CommentsComponent
                    useCase={'task'}
                    id={taskId}
                    owner={task?.owner}
                    manager={task?.manager?.name}
                    descriptionAttachments={task?.description_attachments}
                    successDeletion={(fileId) => {
                        setTask({
                            ...task,
                            description_attachments: task.description_attachments.filter((f) => f.id !== fileId),
                        });
                    }}
                    creationDate={task ? dateUtils.convertTimestampToOnlyDate(task.created_at) : null}
                    comments={comments}
                    fetchComments={() => handleFetchComments()}
                    loadingComments={loadingComments}
                    updateAttachmentName={(name, id) => {
                        handleUpdateAttachmentName(name, id);
                    }}
                    isReadOnly={task?.status === "CLOSED" ? true : false}
                />
            </Container>

            <EditRecurringTaskConfirmModal
                toggle={() => setRecurringTaskEditModalOptions((currentState) => {
                    return {
                        ...currentState,
                        show: false
                    }
                })}
                {...recurringTaskEditModalOptions}
                onConfirm={handleRecurringTaskEditModalConfirm}
            />

            <StatusChangeConfirmModal
                show={showChangeStatusConfirmModal.show}
                toggle={() => {
                    setShowChangeStatusConfirmModal((currentState) => {
                        return {
                            ...currentState,
                            show: false,
                            status: null
                        }
                    })
                }}
                status={showChangeStatusConfirmModal.status}
                onConfirm={handleChangeStatus}
                inProcess={loadingStatus}
            />
        </div>
    );
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        user: state.Login.user,
        token
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps,
        {}
    )(
        withRouter(TaskDetails)
    )
);
